/* The Little Keep - cart drawer upsell progress bar. Loaded site-wide from layout/theme.liquid (Sep 25).
   Global, not inline in the snippet: the drawer is morphed in after load, and inline scripts in morphed HTML never run. */
/* Scroll-linked progress bar (same as Etta Rowe). Listeners live on DOCUMENT, bound once: the drawer
   re-renders its HTML on every cart change and would drop listeners bound to the rail itself. */
(function () {
  if (window.__tlkUpsellBound) { window.__tlkUpsellSync && window.__tlkUpsellSync(); return; }
  window.__tlkUpsellBound = true;
  function sync() {
    var rail = document.getElementById('tlk-upsell-rail'), track = document.getElementById('tlk-upsell-track'), thumb = document.getElementById('tlk-upsell-thumb');
    if (!rail || !track || !thumb) return;
    var max = rail.scrollWidth - rail.clientWidth;
    if (max <= 4) { track.hidden = true; return; }
    track.hidden = false;
    var w = Math.max(rail.clientWidth / rail.scrollWidth * 100, 12);
    thumb.style.width = w + '%';
    thumb.style.transform = 'translateX(' + ((rail.scrollLeft / max) * (100 - w) / w) * 100 + '%)';
  }
  window.__tlkUpsellSync = sync;
  document.addEventListener('scroll', function (e) { if (e.target && e.target.id === 'tlk-upsell-rail') sync(); }, true);
  window.addEventListener('resize', sync);
  document.addEventListener('click', function () { setTimeout(sync, 350); setTimeout(sync, 1200); }, true);
  new MutationObserver(function () { clearTimeout(window.__tlkUpsellT); window.__tlkUpsellT = setTimeout(sync, 150); })
    .observe(document.body, { childList: true, subtree: true });
  setTimeout(sync, 120); setTimeout(sync, 800);
})();
